module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-3-photo-9-0ea147ffe842d5f034e3719ca12932ce.webp";